// extracted by mini-css-extract-plugin
export var chevron = "_ow-1";
export var clickable = "_ow-0";
export var ruleRow = "_ow-2";